import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../shared/dataservice.service';
import { StoreIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ActualDateChange, ActualDateToken, PlannedDateToken, RequestDateToken, GenFileUploads } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';

@Component({
  selector: 'store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit,OnChanges {

  @Input() storeObj: StoreIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;

  public _SSOStatus = SSOStatus;
  Hvr:any = {};

  modifyReqDate:boolean = false;
  modifyPlanDate:boolean = false;
  inputDisableMessage:string = 'This form is not yet enabled';
  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
  }
  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.storeObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.storeObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasStoresEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    this.storeObj.pickListFiles.headerStr = "Loose Material Pick List Files" + " - " + this.storeObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.storeObj.parentSubSORef.subOrderNoId;
    this.storeObj.pickListFiles.disableUpload = this.disableForm;
    this.storeObj.sparePickListFiles.headerStr = "Spare Material Pick List Files" + " - " + this.storeObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.storeObj.parentSubSORef.subOrderNoId;
    this.storeObj.sparePickListFiles.disableUpload = this.disableForm;
  }

  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  requestDateChangeHandler(_reqDateHeader:string, _reqTokenKeyName:string,_plndReqDate:Date,_reqDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the request date changed ?", _reqDateHeader + "(existing)", 
    _plndReqDate, _reqDateHeader + "(edited)", _reqDateChanged, this.storeObj[_reqTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.storeObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.storeObj[_reqTokenKeyName] = 
          new RequestDateToken(new Date(_reqDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.storeObj[_reqTokenKeyName].requestDate = _plndReqDate;
      }
    });
  }


  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.storeObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.storeObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.storeObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.storeObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }


  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.storeObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.storeObj[_actTokenKeyName].actualDate;
    this.storeObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.storeObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.storeObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.storeObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }

  }
  pickListUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showFileManager.emit(this.storeObj.pickListFiles);
  }
  sparePickListUploadClick(_evn:any){
    _evn.stopPropagation();
    this.showFileManager.emit(this.storeObj.sparePickListFiles);
  }
}
